import * as swcHelpers from '@swc/helpers';
import { unwrapResponse } from '../../response.js';
import { acceptJson, postJson, authHeader } from '../../shared.js';

const edit = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, { customerId , accessToken , address , id  }) {
        return unwrapResponse((yield fetch(`${apiUrl}/customers/customers/${encodeURIComponent(customerId)}/addresses/${id}`, {
            method: 'PUT',
            headers: swcHelpers.objectSpread({}, acceptJson, postJson, authHeader(accessToken)),
            body: JSON.stringify(address)
        })));
    });
    return function edit(apiUrl, _) {
        return _ref.apply(this, arguments);
    };
}();

export { edit };
//# sourceMappingURL=edit.js.map
